module.exports = {
  env: 'production',
  apiUrl: '/v1',
  healthUrl: '/healthsecured'
}
